<template>
  <section class="card card-payout active">
    <h2>wypłać z rachunku fx</h2>
    <payout-form />
  </section>
</template>

<script>
import PayoutForm from "@/views/dashboard/partial/_PayoutForm";

export default {
  components: {
    PayoutForm
  }
};
</script>
